import React from 'react';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import CheckboxGroup from 'components/form/CheckboxGroup';
import Divider from '@material-ui/core/Divider';
import useSnack from 'hooks/useSnack';
import { useMutation } from '@apollo/react-hooks';
import { UPDATE_STUDENT_PROFILE } from 'graphql/student/Profile';
import extend from 'lodash/extend';
import Button from 'components/common/Button';
import INTERESTS from 'constant/interests';
import { Box } from '@material-ui/core';
import Input from 'components/form/Input';

const FormItem = Form.FormItem;

const AcademicInterest = ({
  highschool_info,
  user,
  saveText,
  disableCard,
  isSkip,
  onSkip,
  form: { getFieldDecorator, validateFields, getFieldValue },
  step,
  history,
  editable,
}) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_STUDENT_PROFILE);

  const onSubmit = () => {
    return validateFields().then((values) => {
      values = { ...values, completed: true };
      return update({
        variables: {
          id: user.id,
          input: {
            highschool_info: extend(highschool_info, values),
          },
        },
      }).then(
        () => {
          snack.success('Profile saved');
          step && history.push(`/onboarding/${step + 1}`);
        },
        (e) => {
          snack.error(e.message);
        },
      );
    });
  };

  const showOptions = (interestOptions) => {
    let options = interestOptions.map((i) => {
      let string = i.label.replace(/[{()}]/g, '');
      string = string.split('e.g.');
      let label = (
        <Box style={{ paddingTop: '1.5rem' }}>
          <Typography>{string[0]}</Typography>
          <Typography variant="caption">
            {string[1] && `e.g. ${string[1]}`}
            {!string[1] && <span style={{ visibility: 'hidden' }}>Other</span>}
          </Typography>
        </Box>
      );
      let value = i?.value;
      return {
        label,
        value,
      };
    });
    return options;
  };

  const academicInterests =
    getFieldValue('academic_interests') || highschool_info?.academic_interests;

  return (
    <Card className={classes.card} elevation={disableCard && 0}>
      <CardContent className={classes.cardContent}>
        <Grid container spacing={4}>
          <Grid item md={12}>
            <Typography align="center" gutterBottom variant="h3">
              Academic Interests
            </Typography>

            <Typography align="center" variant="caption" paragraph>
              Which areas of study interest you? Feel free to select both
              current interests and those you might want to explore in college!
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              className={classes.activityFormContainer}
            >
              <Form className={classes.formRoot}>
                <FormItem>
                  {getFieldDecorator('academic_interests', {
                    initialValue: highschool_info?.academic_interests,
                    rules: [
                      {
                        required: true,
                        message: 'Please select your academic interests',
                      },
                    ],
                  })(
                    <CheckboxGroup
                      disabled={!editable}
                      setColor={disableCard && 'primary'}
                      size="small"
                      options={showOptions(INTERESTS)}
                    />,
                  )}
                </FormItem>
                {academicInterests?.includes('other') && (
                  <FormItem>
                    {getFieldDecorator('academic_interests_description', {
                      initialValue:
                        highschool_info?.academic_interests_description,
                      rules: [
                        { required: true, message: 'Please enter answer' },
                      ],
                    })(
                      <Input
                        disabled={!editable}
                        label={
                          <Typography color="textSecondary" variant="caption">
                            Describe your academic interests in detail.
                          </Typography>
                        }
                        placeholder="Academic interests"
                      />,
                    )}
                  </FormItem>
                )}
              </Form>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      {!disableCard && <Divider />}
      <CardContent className={classes.footer}>
        <Box display="flex" justifyContent="center">
          {isSkip && (
            <div style={{ marginRight: 24 }}>
              <Button size="large" onClick={onSkip} variant="outlined">
                Skip
              </Button>
            </div>
          )}
          <Button
            editable
            disabled={!editable}
            size="large"
            variant="contained"
            color="primary"
            onClick={onSubmit}
          >
            {saveText || 'Save'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Form.create()(AcademicInterest);
